export const getRowsPerPageOptions = (rows: any[]): number[] => {
  const options = [10, 25, 50, 100];
  const totalRows = rows.length;
  if (totalRows <= 10) {
    return options.slice(0, 0);
  } else if (totalRows <= 20) {
    return options.slice(0, 2);
  } else if (totalRows <= 50) {
    return options.slice(0, 3);
  } else {
    return options;
  }
};
